export default __webpack_public_path__ + "static/media/Icon3.8e65b107.png";